import { fetchFromLambda } from '@agyletime/vue-3-common/src/utils/apiService';
import { ApiQueryParams } from '@/pages/OperationsInsights/types/ApiQueryParams';
import { ApiRespBacklogMetricsByWorkstreams, BacklogMetricsByWorkstream } from '@/pages/OperationsInsights/types/BacklogMetricsResponse';
import { transformDateIntoLocalString } from '@/utils';
import { roundToOneDecimal } from '@/pages/OperationsInsights/utils/roundNumber';
import { EnrichedBacklogMetricsByWorkstream } from '@/pages/OperationsInsights/types/BacklogMetricsResponseEnriched';

const enrichOpenWithinSLA = (metric: EnrichedBacklogMetricsByWorkstream) => {
    const openAtRiskBoP = metric.openAtRiskBoP ?? 0;
    const openBreachedBoP = metric.openBreachedBoP ?? 0;
    const openCountBoP = metric.openCountBoP ?? 0;
    metric.openWithinSLABoP = openCountBoP - (openAtRiskBoP + openBreachedBoP);

    const openAtRiskEoP = metric.openAtRiskEoP ?? 0;
    const openBreachedEoP = metric.openBreachedEoP ?? 0;
    const openCountEoP = metric.openCountEoP ?? 0;
    metric.openWithinSLAEoP = openCountEoP - (openAtRiskEoP + openBreachedEoP);
};

const enrichClosedWithinSLA = (metric: EnrichedBacklogMetricsByWorkstream) => {
    const closedCount = metric.closedCount ?? 0;
    const closedBreached = metric.closedBreached ?? 0;
    metric.closedWithinSLA = closedCount - closedBreached;
};

const enrichAverageTimes = (metric: EnrichedBacklogMetricsByWorkstream) => {
    const closedCount = metric.closedCount ?? 0;
    const totalResolutionTimeSecs = metric.totalResolutionTimeSecs;
    const totalHandleTime = metric.totalHandleTimeSecs;

    metric.averageResolutionTimeInHour = (totalResolutionTimeSecs && closedCount)
        ? roundToOneDecimal((totalResolutionTimeSecs / closedCount) / 3600)
        : 0;

    metric.averageHandleTimeSecs = (totalHandleTime && closedCount)
        ? roundToOneDecimal(totalHandleTime / closedCount)
        : 0;
};

const enrichMetricData = (metricByWorkstream: BacklogMetricsByWorkstream) => {
    enrichOpenWithinSLA(metricByWorkstream as EnrichedBacklogMetricsByWorkstream);
    enrichClosedWithinSLA(metricByWorkstream as EnrichedBacklogMetricsByWorkstream);
    enrichAverageTimes(metricByWorkstream as EnrichedBacklogMetricsByWorkstream);
};

export const fetchBacklogMetricsByWorkstreams = async (params: ApiQueryParams): Promise<ApiRespBacklogMetricsByWorkstreams> => {
    const fromDate = transformDateIntoLocalString(params.fromDate);
    const toDate = transformDateIntoLocalString(params.toDate);
    const fetchUrl =
        '/workactivity/back-office/backlog/snapshot/workstreams?' +
        `fromDate=${fromDate}&toDate=${toDate}&workstreamDefinitionIds=${params.workstreamDefinitionIds.join(',')}`;
    const resp: ApiRespBacklogMetricsByWorkstreams = await fetchFromLambda(fetchUrl);

    if (resp.metrics?.length) {
        resp.metrics.forEach(enrichMetricData);
    }

    return resp;
};